/* src/app/components/identity/login-mfa-selection/login-mfa-selection.component.scss */
.selected-mfa-method {
  border: 1px solid #3f51b5;
}
:host ::ng-deep .mat-mdc-progress-spinner circle,
.mat-mdc-progress-spinner circle {
  stroke: #3f51b5;
}
:host-context(.dark-theme) .selected-mfa-method {
  border: 1px solid #b18a16;
}
:host-context(.dark-theme) :host ::ng-deep .mat-mdc-progress-spinner circle,
:host-context(.dark-theme) .mat-mdc-progress-spinner circle {
  stroke: #D0A010;
}
:host-context(.dark-theme) .choose-method-prompt {
  color: #f2f2f2;
}
.light-theme .selected-mfa-method {
  border: 1px solid #3f51b5;
}
.light-theme ::ng-deep .mat-mdc-progress-spinner circle,
.light-theme .mat-mdc-progress-spinner circle {
  stroke: #3f51b5;
}
/*# sourceMappingURL=login-mfa-selection.component.css.map */
